import React from 'react';

type Props = {
  length: number,
  record: any,
  source: string
};

const TruncatedTextField = ({ source, record = {}, length = 30 }: Props) => {
  let result = record[source].substr(0, length);
  if (record[source].length > length) {
    result += '...'
  }

  return <span style={{ whiteSpace: 'nowrap' }} title={record[source]}>{result}</span>
};

export default TruncatedTextField;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/TruncatedTextField.tsx